import React, { useEffect } from "react";
import * as Yup from "yup";
import {
  Button,
  FormGroup,
  Label,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import {
  Formik,
  Field,
  Form as FormikForm,
  ErrorMessage,
  FormikProps,
} from "formik";
import { useDispatch } from "react-redux";
import { IChangeUserPassword } from "src/models/Maintenance/User.models";

interface FormProps {
  initialValues: IChangeUserPassword;
  loading: boolean;
  loadingLogout: boolean;
  logout: (justLogout?: boolean) => any;
  handleSubmit: (model: IChangeUserPassword) => any; // accion submit (create/update)
}

const oldPassword = "oldPassword";
const newPassword = "newPassword";
const confirmNewPassword = "confirmNewPassword";

const validationSchema: Yup.SchemaOf<IChangeUserPassword> = Yup.object({
  oldPassword: Yup.string()
    .min(5, "Ingrese mínimo 5 caracteres.")
    .max(50, "Ingrese máximo 50 caracteres.")
    .required("Este campo es requerido."),
  newPassword: Yup.string()
    .min(5, "Ingrese mínimo 5 caracteres.")
    .max(50, "Ingrese máximo 50 caracteres.")
    .required("Este campo es requerido."),
  confirmNewPassword: Yup.string()
    .min(5, "Ingrese mínimo 5 caracteres.")
    .max(50, "Ingrese máximo 50 caracteres.")
    .oneOf([Yup.ref("newPassword"), null], "Las contraseñas no coinciden")
    .required("Este campo es requerido."),
  tempPassword: Yup.boolean().required("Este campo es requerido."),
});

export const ChangePasswordForm = React.memo(
  ({
    initialValues,
    handleSubmit,
    loading,
    loadingLogout,
    logout,
  }: FormProps) => {
    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (model: IChangeUserPassword) => {
          handleSubmit(model);
        }}
      >
        {(props: FormikProps<IChangeUserPassword>) => {
          const { touched, errors } = props;
          return (
            <FormikForm id="pageForm">
              <ModalBody>
                <FormGroup className="mt-2">
                  <Label htmlFor={oldPassword}>Contraseña Anterior</Label>
                  <Field
                    id={oldPassword}
                    name={oldPassword}
                    type="password"
                    placeholder="Contraseña anterior..."
                    className={
                      "form-control" +
                      (errors.oldPassword && touched.oldPassword
                        ? " is-invalid"
                        : "")
                    }
                    disabled={loading}
                  />
                  <ErrorMessage
                    name={oldPassword}
                    component="div"
                    className="invalid-feedback"
                  />
                </FormGroup>

                <FormGroup className="mt-2">
                  <Label htmlFor={newPassword}>Nueva Contraseña</Label>
                  <Field
                    id={newPassword}
                    name={newPassword}
                    type="password"
                    placeholder="Nueva contraseña..."
                    className={
                      "form-control" +
                      (errors.newPassword && touched.newPassword
                        ? " is-invalid"
                        : "")
                    }
                    disabled={loading}
                  />
                  <ErrorMessage
                    name={newPassword}
                    component="div"
                    className="invalid-feedback"
                  />
                </FormGroup>

                <FormGroup className="mt-2">
                  <Label htmlFor={confirmNewPassword}>
                    Confirmar Nueva Contraseña
                  </Label>
                  <Field
                    id={confirmNewPassword}
                    name={confirmNewPassword}
                    type="password"
                    placeholder="Confirmar contraseña nueva contraseña..."
                    className={
                      "form-control" +
                      (errors.confirmNewPassword && touched.confirmNewPassword
                        ? " is-invalid"
                        : "")
                    }
                    disabled={loading}
                  />
                  <ErrorMessage
                    name={confirmNewPassword}
                    component="div"
                    className="invalid-feedback"
                  />
                </FormGroup>
              </ModalBody>
              <ModalFooter className="po-relative">
                <React.Fragment>
                  <div
                    hidden={!initialValues?.tempPassword}
                    className="text-center logoutFromModal"
                  >
                    <p hidden={loadingLogout} className="text-muted mb-0">
                      ¿No has solicitado cambio de contraseña?{" "}
                      <span
                        hidden={loadingLogout}
                        onClick={() => {
                          logout(true);
                        }}
                        className="text-primary fw-semibold curpointer"
                      >
                        Cerrar sesión
                      </span>
                    </p>

                    <div style={{ display: "flex" }}>
                      <p hidden={!loadingLogout} className="text-muted mb-0">
                        <b style={{ marginRight: "1rem" }}>
                          Cerrando sesión...
                        </b>
                      </p>

                      <div>
                        <Spinner
                          hidden={!loadingLogout}
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      </div>
                    </div>
                  </div>
                </React.Fragment>

                <Button
                  type="submit"
                  disabled={loading || loadingLogout}
                  color="success"
                >
                  {loading ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : null}
                  {!loading ? "Cambiar" : ""}
                </Button>
              </ModalFooter>
            </FormikForm>
          );
        }}
      </Formik>
    );
  }
);
